import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { Pagination, Select, Text, Icon, Button, theme } from 'components';

const COLUMN_GAP = '15px';

export const StyledOptionsSection = styled.div<{
  $isOpen: boolean;
  $height: number;
  $transition: number;
  $isMobile: boolean;
}>`
  ${({ $isOpen, $height, $isMobile }) => {
    const height = $isMobile ? '' : `height: ${$isOpen ? $height : 0}px;`;
    const overflow = $isMobile ? 'overflow: visible;' : 'overflow: hidden;';
    const opacity = $isOpen ? 'opacity: 1;' : 'opacity: 0;';
    const marginBottom = $isMobile ? 'margin-bottom: 20px;' : '';

    return [height, overflow, opacity, marginBottom].filter(Boolean).join('\n');
  }};
  transition: height 0.2s, opacity 0.2s;
  > div {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    align-items: flex-end;
    column-gap: ${COLUMN_GAP};
    overflow: hidden;
    padding: 0 20px;
    ${Select} {
      width: 100%;
    }
    ${({ $isMobile }) =>
      $isMobile &&
      `
      grid-template-columns: 1fr;
      overflow: visible;
      row-gap: 15px;
      padding: 5px 0 0 0;
      ${Button} {
        margin-top: 15px;
      }
    `}
  }
`;

export const StyledDownloadApply = styled.div`
  display: grid;
  grid-template-columns: auto auto 1fr;
  column-gap: ${COLUMN_GAP};
`;

export const StyledPaneTitle = styled(Text)<{ $active: boolean }>`
  width: 100px;
  text-align: center;
  color: ${({ $active }) =>
    $active ? theme.getColor('textPrimary') : theme.getColor('textSecondary')};
`;

export const StyledSendLink = styled(RouterLink)`
  margin-right: 16px;
  padding-right: 16px;
  border-right: 1px solid ${theme.gray4};
`;

export const StyledTableWrapper = styled.div<{ $marginBottom: number }>`
  margin-bottom: ${({ $marginBottom }) => $marginBottom}px;
`;

export const StyledPagination = styled(Pagination)<{
  $left: number;
  $height: number;
  $transition: number;
}>`
  border-top: 1px solid ${theme.gray3};
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: ${({ $left }) => $left}px;
  width: ${({ $left }) => `calc(100vw - ${$left}px)`};
  height: ${({ $height }) => $height}px;
  transition: all ${({ $transition }) => $transition}s;
`;

export const StyledIgnoreCursor = styled.span`
  pointer-events: none;
`;

export const StyledMobileCell = styled.div`
  display: grid;
  grid-template-columns: 65px calc(100% - 65px);
  grid-column-gap: 10px;

  div:first-child {
    grid-row-end: span 2;
  }
  ${Text} {
    max-width: 100%;
  }
  ${Text}.line2 {
    margin-left: 10px;
  }
`;

export const StyledCircle = styled(Icon)`
  margin: 5px;
  vertical-align: text-bottom;
`;
